import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select';
import DatePicker from "web/components/DatePicker";
import * as moment from "moment";
import Spinner from 'web/components/Spinner'
import AlertModal from 'web/components/AlertModal';
import YesNoModal from "web/components/YesNoModal";
import { Modal, ModalBody } from 'reactstrap';
import { VendorPricingAddModal } from '../VendorPricingStyled'
import CloseIcon from "web/assets/images/CloseIcon.png";
import { ptPlusVendorPricingAddMoreVendorData } from "redux/actions/adminPTPlusVendorPricing";

function VendorPricingEditModal(props) {
  const { closeModal, vendorLocationList, addMoreSelectedItem } = props
  const token = localStorage.getItem("token")
  const dispatch = useDispatch();
  let history = useHistory();

  const [loader, setLoader] = useState(false)
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible)

  const vendorFeeDetails = addMoreSelectedItem.feeDetail
  const vendorPalletDetails = addMoreSelectedItem.feeDetail?.palletDetails

  const [expDate, setExpDate] = useState(vendorFeeDetails?.rateExpirationDate)
  const [dateError, setDateError] = useState()
  const [commentValue, setCommentValue] = useState(vendorFeeDetails?.comment)

  const [alertModal, setAlertModal] = useState(false)
  const [alertModalContent, setAlertModalContent] = useState('')
  const [alertModalType, setAlertModalType] = useState()
  const [yesNoModalContent, setYesNoModalContent] = useState("");
  const [yesNomodal, setYesNoModal] = useState(false);

  const hardOrSoftWoodDiv = () => {
    return (
      <div className="checkbox-styles-disable-view">
        <label>
          <input
            type="checkbox"
            checked={vendorPalletDetails?.newConditionType === "HARDWOOD"}
            disabled
          />
          New - HW
        </label>
        <label style={{ marginLeft: '20px' }}>
          <input
            type="checkbox"
            checked={vendorPalletDetails?.newConditionType === "SOFTWOOD"}
            disabled
          />
          New - SW
        </label>
      </div>
    );
  };

  const submitEditForm = async () => {
    let data = {
      id: addMoreSelectedItem?.id,
      update: true,
      vendorPricing: null,
      updateReq: {
        vendorLocationId: addMoreSelectedItem.vendorDetails?.vendorLocationId,
        feeId: vendorFeeDetails?.feeId,
        rateExpirationDate: moment(expDate).format("YYYY-MM-DD"),
        comment: commentValue
      }
    }
    // this same api is used for edit a vendor record as well
    let response = await dispatch(ptPlusVendorPricingAddMoreVendorData(data, token));
    if (response?.success) {
      setAlertModalType('addSuccess')
      setAlertModalContent(response?.data?.msg)
      setAlertModal(true);
    } else {
      if (response?.statusCode === 401) {
        history.push('./sign-in')
      } else {
        setAlertModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setAlertModal(true);
      }
    }
  }

  return (
    <>
      <Modal isOpen={true} centered={true} size={'lg'} className="vendor-pricing-modal-style">
        <VendorPricingAddModal>
          <ModalBody>
            {(loaderVisible || loader) && <Spinner />}
            <div>
              <div className="main-header">
                <h4>Edit Vendor Pricing</h4>
                <img src={CloseIcon} alt="close-icon" onClick={() => {
                  closeModal()
                }} />
              </div>
              <div className="new-data-add-section-style">
                <div className="outer-wrapper">
                  <div className="top-row-style">
                    <Select
                      id="vendorLocationId"
                      name='vendorLocationId'
                      value={{ label: `${addMoreSelectedItem?.vendorDetails?.vendorLocationName} - ${addMoreSelectedItem?.vendorDetails?.city}, ${addMoreSelectedItem?.vendorDetails?.state}`, value: addMoreSelectedItem?.vendorDetails?.vendorLocationId }}
                      isDisabled
                      onChange={() => { }}
                      options={vendorLocationList}
                      placeholder="Vendors*"
                    />
                    <Select
                      id="material"
                      name='material'
                      value={{ label: vendorPalletDetails?.material, value: vendorPalletDetails?.material }}
                      isDisabled
                      onChange={() => { }}
                      options={[{ label: vendorPalletDetails?.material, value: vendorPalletDetails?.material }]}
                      placeholder="Material*"
                    />
                    {(vendorPalletDetails?.condition?.length > 0 && vendorPalletDetails?.condition !== '') &&
                      <Select
                        id="condition"
                        name='condition'
                        value={{ label: vendorPalletDetails?.condition?.join(), value: vendorPalletDetails?.condition?.join() }}
                        isDisabled
                        onChange={() => { }}
                        options={[{ label: vendorPalletDetails?.condition?.join(), value: vendorPalletDetails?.condition?.join() }]}
                        placeholder="Condition*"
                      />
                    }
                    {(vendorPalletDetails?.material === 'WOOD' && vendorPalletDetails?.condition?.join() === 'NEW') && hardOrSoftWoodDiv()}
                  </div>
                  <div className="pallet-details-row-style">
                    {(vendorPalletDetails?.palletType && vendorPalletDetails?.palletType !== "" && vendorPalletDetails?.palletType !== "CUSTOM") &&
                      <Select
                        id="palletType"
                        name='palletType'
                        value={{ label: vendorPalletDetails?.palletType, value: vendorPalletDetails?.palletType }}
                        isDisabled
                        onChange={() => { }}
                        options={[{ label: vendorPalletDetails?.palletType, value: vendorPalletDetails?.palletType }]}
                        placeholder="Pallet Type*"
                      />
                    }
                    {(vendorPalletDetails?.moisture && vendorPalletDetails?.moisture !== "") &&
                      <Select
                        id="moisture"
                        name='moisture'
                        value={{ label: vendorPalletDetails?.moisture, value: vendorPalletDetails?.moisture }}
                        isDisabled
                        onChange={() => { }}
                        options={[{ label: vendorPalletDetails?.moisture, value: vendorPalletDetails?.moisture }]}
                        placeholder="Moisture*"
                      />
                    }
                    {(vendorPalletDetails?.palletType !== "CUSTOM" && vendorPalletDetails?.size && vendorPalletDetails?.size !== "") &&
                      <Select
                        id="size"
                        name='size'
                        value={{ label: vendorPalletDetails?.size, value: vendorPalletDetails?.size }}
                        isDisabled
                        onChange={() => { }}
                        options={[{ label: vendorPalletDetails?.size, value: vendorPalletDetails?.size }]}
                        placeholder="Size*"
                      />
                    }
                    {(vendorPalletDetails?.grade && vendorPalletDetails?.grade !== '') &&
                      <Select
                        id="grade"
                        name='grade'
                        value={{ label: vendorPalletDetails?.grade, value: vendorPalletDetails?.grade }}
                        isDisabled
                        onChange={() => { }}
                        options={[{ label: vendorPalletDetails?.grade, value: vendorPalletDetails?.grade }]}
                        placeholder="Grade*"
                      />
                    }
                    {(vendorPalletDetails?.length && vendorPalletDetails?.length !== '') && (
                      <div className="custom-size-styles">
                        <div className="number-div-style">{vendorPalletDetails?.length}</div>
                        <div className="number-div-style">{vendorPalletDetails?.width}</div>
                        <div className="number-div-style">{vendorPalletDetails?.height}</div>
                      </div>
                    )}
                    {(vendorPalletDetails?.palletType !== "CUSTOM" && vendorPalletDetails?.size && vendorPalletDetails?.size !== "") && (
                      <div className="checkbox-styles-disable-view">
                        <label>
                          <input
                            type="checkbox"
                            checked={vendorPalletDetails?.heatTreared}
                            disabled
                          />
                          Heat Treated
                        </label>
                      </div>
                    )}
                    <div className="checkbox-styles-disable-view">
                      <label>
                        <input
                          type="checkbox"
                          checked={vendorFeeDetails?.equipment === 'LTL'}
                          disabled
                        />
                        LTL
                      </label>
                    </div>
                  </div>
                  <div className="vendor-pricing-style">
                    <div className="number-div-style">{parseFloat(vendorFeeDetails?.vendorFee)?.toFixed(2)}</div>
                    <div className="disable-date-style">
                      <DatePicker
                        name='rateStartDate'
                        maxDOBirth={vendorFeeDetails?.rateExpirationDate}
                        value={vendorFeeDetails?.rateStartDate}
                        disabled={true}
                        type="buyBackFeeForm"
                        callBackFun={() => { }}
                      />
                    </div>
                    <p>To</p>
                    <div>
                      <DatePicker
                        name='rateExpirationDate'
                        minDOBirth={vendorFeeDetails.rateStartDate}
                        value={expDate}
                        type="buyBackFeeForm"
                        callBackFun={(date, value) => {
                          setExpDate(value)
                          if (value === null) setDateError('Date cannot be empty.')
                          else if (isNaN(new Date(date).getTime())) setDateError('Invalid Date.')
                          else if (moment(value).isBefore(moment(vendorFeeDetails.rateStartDate), 'day')) setDateError('End Date must be after Start Date.')
                          else setDateError()
                        }}
                      />
                      {dateError && <p className="error-message">{dateError}</p>}
                    </div>
                    <div className="text-area-style">
                      <textarea
                        placeholder='Comment'
                        value={commentValue}
                        rows="1"
                        onChange={(e) => setCommentValue(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="add-button-style">
                    <button
                      style={{ opacity: dateError ? 0.5 : 1 }}
                      disabled={dateError}
                      onClick={submitEditForm}
                    >Update</button>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </VendorPricingAddModal>
      </Modal>

      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        content={alertModalContent}
        alertType='success'
        callBackAlert={() => {
          if (alertModalType === 'addSuccess') {
            closeModal('addSuccess')
          }
        }}
      />
      <YesNoModal
        isOpen={yesNomodal}
        toggle={() => setYesNoModal(!yesNomodal)}
        title=""
        content={yesNoModalContent}
        link={'/'}
        type={''}
        onClickHander={(val) => {
          setYesNoModal(!yesNomodal)
        }}
      />
    </>
  );
}

export default VendorPricingEditModal;
